export const sxStyle = {
  media: {
    width: '100%',
    height: { xs: '141px', sm: '320px' },
    borderRadius: { xs: '4px', sm: '8px' },
  },
  textWithIcons: {
    display: 'flex',
    verticalAlign: 'text-bottom',
    boxSizing: 'inherit',
    alignItems: 'center',
    color: '#000',
    fontSize: '15px',
  },
  icon: {
    color: '#000 !important',
    fontSize: { xs: '1.3rem !important', sm: '1.6rem !important' },
    mr: { xs: '8px', sm: '10px' },
  },
  remarksStyle: {
    fontSize: { xs: '14px', sm: '16px' },
  },
  gridRooms: { mb: '10px' },
  divider: {
    mb: '10px',
    color: '#000',
  },
  rooms: {
    fontSize: { xs: '14px', sm: '16px' },
    color: '#000',
  },
  buttonWithIcons: {
    width: '100%',
    mt: '10px',
    display: 'flex',
    verticalAlign: 'text-bottom',
    boxSizing: 'border-box',
    alignItems: 'center',
    color: '#000',
    fontSize: { xs: '14px', sm: '18px' },
    fontWeight: 600,
    border: 'solid 1px #000',
    bgcolor: '#E5E5E5',
    borderRadius: '8px',
  },
};
